import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';

@Component({
  selector: 'app-hotel-switch-button',
  standalone: false,
  templateUrl: './hotel-switch-button.component.html',
  styleUrls: ['./hotel-switch-button.component.scss']
})
export class HotelSwitchButtonComponent {
  @Output() switchToHotel = new EventEmitter<void>();

  ServiceType = ServiceType;

  constructor(public searchService: EnterpriseSearchService) {}

  onSwitchClick(): void {
    this.switchToHotel.emit();
  }
}
